module.exports = __webpack_public_path__ + "static/media/ОлимиА.65b155df.pdf";